import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBIntFieldObjective, DBDropDown, DBTextArea, ToolTipBulb } from '_components';
import styles from './NonMaterialHandling.module.css';
import { noteActions } from '_actions';

class PatientCareCenterNoteObjectiveNonMaterialHandling extends React.Component {

    render() {
        let options = [
            { id: 'Occasional', value: 'Occasional' },
            { id: 'Frequent', value: 'Frequent' },
            { id: 'Constant', value: 'Constant' },
            { id: 'N/A', value: 'N/A' },
            { id: 'N/T', value: 'N/T' }
        ];
        return (
            <PatientCareCenterNoteSection id='nonMaterialHandling' name='Non Material Handling' refProp={this.props.refProp} level={5}>
                <div className={styles.row}>
                    <label className={styles.col1}><strong>Client can:</strong></label>
                    <label className={styles.col2}><strong>Job Requirement</strong></label>
                    <label className={styles.col3}><strong>Today's Measurements</strong></label>
                </div>
               

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Walk</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMWALKJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMWALKCUR'
                        customOptions={options}
                    />
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Sit</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSITJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSITCUR'
                        customOptions={options}
                    />
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Stand</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSTANDJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSTANDCUR'
                        customOptions={options}
                    />
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Balance 25 ft.</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMBALANCEJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMBALANCECUR'
                        customOptions={options}
                    />
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Kneel</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMKNEELJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMKNEELCUR'
                        customOptions={options}
                    />
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Crawl 25 ft.</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMCRAWLJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMCRAWLCUR'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Reach Overhead</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMOVERHEADJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMOVERHEADCUR'
                        customOptions={options}
                    />
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Reach Forward</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMFORWARDJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMFORWARDCUR'
                        customOptions={options}
                    />
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Bend</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMBENDJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMBENDCUR'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Squat</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSQUATJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSQUATCUR'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Twist</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMTWISTJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMTWISTCUR'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Ladder Climb</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMLADDERJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMLADDERCUR'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Stair Climb</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSTAIRJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMSTAIRCUR'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Manual Dexterity</label>
                    </div>
                   
                    <div className={styles.col2_row}>
                   
                        <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMDEXTERITYJOB'
                        customOptions={options}
                    />
                    </div>
                    
                    <div className={styles.col3_row}>

                    <DBDropDown
                        className={styles.drop_down}
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVENONMATHAND'
                        entityKeyColumn='NMNO'
                        entityKeyValue={this.props.nmno}
                        field='NMDEXTERITYCUR'
                        customOptions={options}
                    />
                    </div>
                </div>

                <div className={styles.row}>
                <div className={styles.col1_row}>
                        <label><strong>Comments</strong></label>
                    </div>
                </div>
              
               
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVENONMATHAND'
                    entityKeyColumn='NMNO'
                    entityKeyValue={this.props.nmno}
                    field='NMCOMMENTS'
                    className={styles.textarea}
                />
            </PatientCareCenterNoteSection>
        );
    }
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let nmno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVENONMATHAND)
        .find(key => (state.entities.notes.PTOBJECTIVENONMATHAND[key].NMEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVENONMATHAND[key].NMNTNO === pk && noteType !== 1)));

    return {
        noteId,
        nmno,
    };
}

const connectedPatientCareCenterNoteObjectiveNonMaterialHandling= connect(mapStateToProps)(PatientCareCenterNoteObjectiveNonMaterialHandling);
export { connectedPatientCareCenterNoteObjectiveNonMaterialHandling as PatientCareCenterNoteObjectiveNonMaterialHandling };

